export default "__VITE_ASSET__B4hlfC9C__"